module.exports = __webpack_public_path__ + "img/stjt.8b06c38f.png";